import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { Megaphone } from 'lucide-react'
import { systemApi } from '@/lib/api'
import { formatDate } from '@/lib/utils'

// Shares the query key (and polling) with MaintenanceGate, so the banner
// appears and disappears on its own too: the server already stops
// returning notice fields once the announced window has passed.
const POLL_MS = 20_000

export default function MaintenanceBanner() {
  const { t, i18n } = useTranslation()

  const { data } = useQuery({
    queryKey: ['system', 'maintenance'],
    queryFn: systemApi.getMaintenance,
    refetchInterval: POLL_MS,
    retry: false,
  })

  if (!data?.notice_reason || !data.notice_start || !data.notice_end) return null

  return (
    <div className="flex items-center gap-2 px-4 py-2 text-sm bg-giallo-light dark:bg-giallo/10 border-b border-giallo/40 text-giallo-dark dark:text-giallo">
      <Megaphone className="w-4 h-4 flex-shrink-0" />
      <span>
        <strong>{t('maintenance.bannerLabel')}:</strong>{' '}
        {formatDate(data.notice_start, i18n.language)} → {formatDate(data.notice_end, i18n.language)} — {data.notice_reason}
      </span>
    </div>
  )
}
